export class SearchParam {
    countInPage: number;
    partNumber: number;
    filter: Record<string, any>;
    sort: Record<string, any>;

    constructor(countInPage: number, partNumber: number, filter: Record<string, any>, sort: Record<string, any>) {
        this.countInPage = countInPage;
        this.partNumber = partNumber;
        this.filter = filter;
        this.sort = sort;
    }
}